/* unplugin-vue-components disabled */import { render } from "./HomeView.vue?vue&type=template&id=faed04ee&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=faed04ee&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faed04ee"]])

export default __exports__